import Chat from "../components/chat/chat.component";

const ChatPage = () => <Chat />;

export default ChatPage;
